import { useCallback, useState } from "react";
import type { FormInstance } from "@ir/ui";

export type ConfigAddEditModalMode = "create" | "edit";

/**
 * Shared create/edit modal state for Config writable list pages.
 */
export function useConfigAddEditModal<TEntity>() {
  const [modalMode, setModalMode] = useState<ConfigAddEditModalMode | null>(
    null,
  );
  const [editingEntity, setEditingEntity] = useState<TEntity | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isFormSubmittable, setIsFormSubmittable] = useState(false);

  const closeModal = useCallback((form: FormInstance) => {
    setModalMode(null);
    setEditingEntity(null);
    setIsFormSubmittable(false);
    form.resetFields();
  }, []);

  const openCreateModal = useCallback(() => {
    setEditingEntity(null);
    setModalMode("create");
    setIsFormSubmittable(false);
  }, []);

  const openEditModal = useCallback((entity: TEntity) => {
    setEditingEntity(entity);
    setModalMode("edit");
    setIsFormSubmittable(false);
  }, []);

  return {
    modalMode,
    editingEntity,
    isSaving,
    setIsSaving,
    isFormSubmittable,
    setIsFormSubmittable,
    closeModal,
    openCreateModal,
    openEditModal,
  };
}

export function formatConfigRecordCount(
  loading: boolean,
  total: number,
): string {
  if (loading) {
    return "Loading...";
  }
  return total === 1 ? "1 record" : `${total} records`;
}
